import { Box } from '@mui/material';

import Logo from '../../assets/media/Western_Cape_Government_logo.png';
import LogoWhite from '../../assets/media/HulaTechLogoWhite.svg';

interface HulaTechLogoProps {
  height?: string;
  width?: string;
  variant?: string;
}
const WcedLogo: React.FC<HulaTechLogoProps> = ({ width = '300px', height = 'auto', variant }) => {
  return (
    <Box>
      <img src={variant === 'white' ? LogoWhite : Logo} alt="WCED" height={height} width={width} />
    </Box>
  );
};

export default WcedLogo;
